export default __webpack_public_path__ + "static/media/filter.607277fc.png";